module.exports = __webpack_public_path__ + "img/gif-card.7c04bf6d.svg";